module.exports = __webpack_public_path__ + "img/Slice23.e9af4041.png";